import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b45ba16c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar start" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "onlineIndicator" }, null, -1))
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "powered by Agentur Philipp.", -1))
const _hoisted_7 = { class: "message-container" }
const _hoisted_8 = {
  class: "messages",
  id: "messages"
}
const _hoisted_9 = {
  key: 0,
  class: "loading"
}
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["placeholder", "onKeyup", "disabled"]

import { PropType, computed, ref, onMounted, watch, nextTick } from 'vue'
import Company from '@/entities/domain/Company/Company';
import Close from '@/components/svg/Close.vue';
import { InputModes } from "@/entities/domain/FirstLevelSupport/FirstLevelSupport";
import SingleMessage from '@/components/Elements/Chatbot/SingleSupportMessage.vue';
import ArrowLeft from '@/components/svg/ArrowLeft.vue';
import PaperPlane from '@/components/svg/PaperPlane.vue';
import Typing from '@/components/BaseComponents/Typing.vue';
import GetDocumentElementById from '@/utils/GetDocumentElementById';
import DropDownSelect from '@/components/BaseComponents/DropDownSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FirstLevelSupportChat',
  props: {
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
    avatar: {
        type: String,
        required: true,
    }
},
  emits: ['close', 'open', 'goBack'],
  setup(__props, { emit: __emit }) {

const emits = __emit;


const props = __props

const input = ref(null)
const userInput = ref("" as string);
const inputPlaceholder = ref("");
const windowHeight = ref(0);
const inputMode = ref(InputModes.NONE)

const chatbotTexts = computed(() => {
    return props.company.FrontendDesign?.ProductWizard?.TextConventions ?? undefined;
})

const updateWindowHeight = () => {
    setTimeout(() => windowHeight.value = window.visualViewport?.height ?? window.innerHeight, 500)
}

const updateScroll = async (messageIdToScrollTo?: number) => {
    await nextTick();
    await nextTick();
    const messageWindow = GetDocumentElementById("messages");
    if (messageWindow && !messageIdToScrollTo) {
        messageWindow.scrollTop = messageWindow.scrollHeight;
        return;
    }

    if (messageWindow && messageIdToScrollTo) {
        const selectedMessage = document.getElementById("message-" + messageIdToScrollTo);

        if (!selectedMessage) return;

        messageWindow.scrollTop = selectedMessage.offsetTop;
        return;
    }
}

watch(() => props.company.FirstLevelSupport?.MessageHistory, () => {
    setTimeout(() =>
        updateScroll(props.company.FirstLevelSupport?.MessageHistory?.[props.company.FirstLevelSupport?.MessageHistory?.length - 1]?.Id), 1000)
})

const openPackageTracking = () => {
    inputMode.value = InputModes.TRACKING;
    inputPlaceholder.value = "Gib deine Sendungsnummer ein";
    if (input.value)
        (input.value as HTMLInputElement).focus();
}

const sendInput = async () => {
    if (inputMode.value === InputModes.TRACKING && userInput.value) {
        await props.company.FirstLevelSupport?.GetTracking(userInput.value, props.company.selectedLanguage)
        inputMode.value = InputModes.NONE;
        inputPlaceholder.value = "";
        userInput.value = "";
    }

    updateScroll(props.company.FirstLevelSupport?.MessageHistory?.[props.company.FirstLevelSupport?.MessageHistory?.length - 1]?.Id);
}

onMounted(() => {
    props.company.FirstLevelSupport?.setScrollFuntion(updateScroll);
    updateScroll(props.company.FirstLevelSupport?.MessageHistory?.[props.company.FirstLevelSupport?.MessageHistory?.length - 1]?.Id);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ fullscreen: props.company.CompanyQuizConfig.FullscreenMode }, "messageWindow"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ArrowLeft, {
        fill: __props.company.FrontendDesign?.ProductWizard?.FontColorPrimary,
        class: "backbutton",
        onClick: _cache[0] || (_cache[0] = () => emits('goBack'))
      }, null, 8, ["fill"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["avatar", { center: true, border: chatbotTexts.value?.showIconBorder === 'true' }]),
          style: _normalizeStyle({ backgroundColor: __props.company.FrontendDesign?.ProductWizard?.IconBackgroundColor ?? __props.company.FrontendDesign?.ProductWizard?.PrimaryColor })
        }, [
          _createElementVNode("img", { src: __props.avatar }, null, 8, _hoisted_3),
          _createTextVNode(),
          _hoisted_4
        ], 6),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(chatbotTexts.value?.name ?? "ProductWizard") + " ", 1),
          _hoisted_6
        ])
      ]),
      _createVNode(Close, {
        class: "close",
        fill: __props.company.FrontendDesign?.ProductWizard?.FontColorPrimary,
        onClick: _cache[1] || (_cache[1] = (e) => {
                if (__props.company.CompanyQuizConfig.FullscreenMode)
                    () => emits('goBack');
                else emits('close')
            })
      }, null, 8, ["fill"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.company.FirstLevelSupport?.MessageHistory, (message) => {
          return (_openBlock(), _createBlock(SingleMessage, {
            message: message,
            key: message.Id,
            company: __props.company,
            productRecommendation: message.ProductRecommendations,
            ref_for: true,
            ref: message.Id.toString(),
            id: 'message-' + message.Id,
            avatar: __props.avatar,
            "first-level-support": __props.company.FirstLevelSupport!,
            onOpenProductConsultant: _cache[2] || (_cache[2] = ($event: any) => (emits('open'))),
            onOpenPackageTracking: openPackageTracking,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
          }, null, 8, ["message", "company", "productRecommendation", "id", "avatar", "first-level-support"]))
        }), 128))
      ]),
      (__props.company.FirstLevelSupport?.IsLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(Typing)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (inputMode.value !== _unref(InputModes).SELECT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: inputPlaceholder.value,
              onKeyup: _withKeys(sendInput, ["enter"]),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userInput).value = $event)),
              ref_key: "input",
              ref: input,
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (updateWindowHeight())),
              disabled: inputMode.value === _unref(InputModes).NONE
            }, null, 40, _hoisted_12), [
              [_vModelText, userInput.value]
            ]),
            _createVNode(PaperPlane, {
              hoverColor: "#1d74f5",
              onClick: sendInput
            })
          ]))
        : (_openBlock(), _createBlock(DropDownSelect, { key: 1 }))
    ])
  ], 2))
}
}

})